import styled from 'styled-components'

export const ScrollableTableContainer = styled.div`
  max-height: 13rem;
  overflow-y: auto;
  overflow-x: visible;
  margin-top: 0.5rem;
  padding: 0.25rem;

  @media (max-width: 768px) {
    max-height: 9rem;
  }
`
